import { render, staticRenderFns } from "./hx-home-content.vue?vue&type=template&id=890f4fce&"
import script from "./hx-home-content.vue?vue&type=script&lang=js&"
export * from "./hx-home-content.vue?vue&type=script&lang=js&"
import style0 from "./hx-home-content.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports